import { render, staticRenderFns } from "./modal-terms-and-conditions-freestyle.vue?vue&type=template&id=02d1c386"
import script from "./modal-terms-and-conditions-freestyle.vue?vue&type=script&lang=js"
export * from "./modal-terms-and-conditions-freestyle.vue?vue&type=script&lang=js"
import style0 from "./modal-terms-and-conditions-freestyle.vue?vue&type=style&index=0&id=02d1c386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports